var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('highcharts',{staticStyle:{"height":"600px","width":"90%","margin":"auto","padding":"25px"},attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }